// Import sponsor logos from assets
import punjabTourismLogo from '@/assets/images/sponsors/punjab-tourism.jpg'
import foodTrailsLogo from '@/assets/images/sponsors/food-trails-india.jpg'
import ngoPartnerLogo from '@/assets/images/sponsors/ngo-partner.jpg'
import bikestoreLogo from '@/assets/images/sponsors/the-bikestore.jpg'

function slugify(s) {
  return s
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '')
}

export const INDIAN_STATES = [
  { name: 'Select a State', code: '', coordinates: [20.5937, 78.9629] },

  { name: 'Andaman & Nicobar Islands', code: 'AN', coordinates: [11.7401, 92.6586] },
  { name: 'Andhra Pradesh', code: 'AP', coordinates: [15.9129, 79.7400] },
  { name: 'Arunachal Pradesh', code: 'AR', coordinates: [28.2180, 94.7278] },
  { name: 'Assam', code: 'AS', coordinates: [26.2006, 92.9376] },
  { name: 'Bihar', code: 'BR', coordinates: [25.0961, 85.3131] },
  { name: 'Chhattisgarh', code: 'CG', coordinates: [21.2787, 81.8661] },
  { name: 'Chandigarh', code: 'CH', coordinates: [30.7333, 76.7794] },

  // DH in backend: Dadra & Nagar Haveli / Daman and Diu combined UT (approx. Silvassa / Daman)
  { name: 'Dadra & Nagar Haveli / Daman & Diu', code: 'DH', coordinates: [20.27, 72.99] },

  { name: 'Delhi', code: 'DL', coordinates: [28.6139, 77.2090] },
  { name: 'Goa', code: 'GA', coordinates: [15.2993, 74.1240] },
  { name: 'Gujarat', code: 'GJ', coordinates: [22.2587, 71.1924] },
  { name: 'Haryana', code: 'HR', coordinates: [29.0588, 76.0856] },
  { name: 'Himachal Pradesh', code: 'HP', coordinates: [31.1048, 77.1734] },
  { name: 'Jammu & Kashmir', code: 'JK', coordinates: [33.7782, 76.5762] },
  { name: 'Jharkhand', code: 'JH', coordinates: [23.6102, 85.2799] },

  { name: 'Karnataka', code: 'KA', coordinates: [15.3173, 75.7139] },
  { name: 'Kerala', code: 'KL', coordinates: [10.8505, 76.2711] },
  { name: 'Ladakh', code: 'LA', coordinates: [34.1526, 77.5770] },
  { name: 'Lakshadweep', code: 'LD', coordinates: [10.5667, 72.6417] },

  { name: 'Madhya Pradesh', code: 'MP', coordinates: [22.9734, 78.6569] },
  { name: 'Maharashtra', code: 'MH', coordinates: [19.7515, 75.7139] },
  { name: 'Manipur', code: 'MN', coordinates: [24.6637, 93.9063] },
  { name: 'Meghalaya', code: 'ML', coordinates: [25.4670, 91.3662] },
  { name: 'Mizoram', code: 'MZ', coordinates: [23.1645, 92.9376] },

  { name: 'Nagaland', code: 'NL', coordinates: [26.1584, 94.5624] },
  { name: 'Odisha', code: 'OD', coordinates: [20.9517, 85.0985] },
  { name: 'Puducherry', code: 'PY', coordinates: [11.9416, 79.8083] },
  { name: 'Punjab', code: 'PB', coordinates: [31.1471, 75.3412] },
  { name: 'Rajasthan', code: 'RJ', coordinates: [27.0238, 74.2179] },

  { name: 'Sikkim', code: 'SK', coordinates: [27.5330, 88.5122] },
  { name: 'Tamil Nadu', code: 'TN', coordinates: [11.1271, 78.6569] },
  { name: 'Telangana', code: 'TG', coordinates: [18.1124, 79.0193] },
  { name: 'Tripura', code: 'TR', coordinates: [23.9408, 91.9882] },

  { name: 'Uttar Pradesh', code: 'UP', coordinates: [26.8467, 80.9462] },
  { name: 'Uttarakhand', code: 'UK', coordinates: [30.0668, 79.0193] },
  { name: 'West Bengal', code: 'WB', coordinates: [22.9868, 87.8550] },
];

export const EVENT_TYPES = [
  { value: "cycle_tour", label: "Cycle Tour" },
  { value: "cycle_kumbh", label: "Cycle Kumbh" },
  { value: "flash_mob", label: "Flash Mob" },
  { value: "koset_ride", label: "Koset Ride" },
];

export const SPONSORSHIP_COMPONENTS = [
  { value: "hydration", label: "Hydration" },
  { value: "medals", label: "Medals" },
  { value: "nutrition", label: "Nutrition" },
  { value: "apparels", label: "Apparels" },
  { value: "gears", label: "Gears" },
  { value: "spares", label: "Spares" },
  { value: "accessories", label: "Accessories" },
  { value: "registration_fees", label: "Registration Fees" },
  { value: "insurance", label: "Insurance" },
  { value: "bikes", label: "Bikes" },
  { value: "certificates", label: "Certificates" },
  { value: "route_signages", label: "Route Signages" },
  { value: "branding", label: "Branding" },
  { value: "finance_and_support_vehicles", label: "Finance & Support Vehicles" },
];

/**
 * Get display label for a sponsorship component value.
 */
export const getComponentLabel = (value) => {
  const comp = SPONSORSHIP_COMPONENTS.find(c => c.value === value);
  return comp ? comp.label : value?.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase()) || "Unknown";
};

// =============================
// INTEREST STATUS CONFIG (single source of truth)
// =============================

export const INTEREST_STATUS_CONFIG = {
  pending: {
    label: "Pending",
    tone: "info",
    tailwind: "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400",
  },
  reviewed: {
    label: "Reviewed",
    tone: "muted",
    customStyle: { background: "#EDE9FE", color: "#6D28D9" },
    tailwind: "bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400",
  },
  partially_accepted: {
    label: "Partially Accepted",
    tone: "muted",
    customStyle: { background: "#FEF3C7", color: "#92400E" },
    tailwind: "bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400",
  },
  accepted: {
    label: "Accepted",
    tone: "success",
    tailwind: "bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400",
  },
  declined: {
    label: "Declined",
    tone: "danger",
    tailwind: "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400",
  },
};

/**
 * Get the Badge-component-friendly config for a given interest status.
 * Returns { label, tone, customStyle? }
 */
export const getInterestStatusBadgeConfig = (status) => {
  return INTEREST_STATUS_CONFIG[status] || {
    label: status?.replace(/_/g, " ") || "Unknown",
    tone: "muted",
  };
};

/**
 * Get Tailwind CSS classes for a given interest status (for inline <span> badges).
 */
export const getInterestStatusTailwind = (status) => {
  return (INTEREST_STATUS_CONFIG[status]?.tailwind) || "bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-300";
};

/**
 * Check if a status is considered "final" (no further review action needed).
 */
export const isInterestStatusFinal = (status) => {
  return ["reviewed", "accepted", "declined", "partially_accepted"].includes(status);
};

export const MOCK_EVENTS = [
  {
    id: 1,
    title: 'City Cycling Tour',
    date: 'May 15, 2024',
    location: 'Mumbai',
    participants: 150,
    image: 'https://i0.wp.com/picjumbo.com/wp-content/uploads/hotel-atlantis-on-top-of-the-palm-in-dubai-free-image.jpg?w=2210&quality=70',
    description: 'Explore the vibrant streets of Mumbai on this guided cycling tour.'
  },
  {
    id: 2,
    title: 'Mountain Trail Challenge',
    date: 'May 22, 2024',
    location: 'Manali',
    participants: 75,
    image: 'https://i0.wp.com/picjumbo.com/wp-content/uploads/luxury-and-minimalistic-black-villa-with-a-pool-on-the-rocky-coast-free-image.jpeg?w=2210&quality=70',
    description: 'Take on the challenging mountain trails of Himachal Pradesh.'
  },
  {
    id: 3,
    title: 'Coastal Ride Experience',
    date: 'May 29, 2024',
    location: 'Goa',
    participants: 200,
    image: 'https://images.unsplash.com/photo-1571068316344-75bc76f77890?w=400',
    description: 'Ride along the beautiful coastline of Goa with fellow cyclists.'
  },
  {
    id: 4,
    title: 'Heritage Cycle Rally',
    date: 'June 5, 2024',
    location: 'Delhi',
    participants: 120,
    image: 'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=400',
    description: 'Discover Delhi\'s rich heritage on this educational cycling tour.'
  },
]

// Updated SPONSORS with imported assets
export const SPONSORS = [
  {
    id: 1,
    name: 'Punjab Tourism',
    logo: punjabTourismLogo,
    website: 'https://punjabtourism.gov.in'
  },
  {
    id: 2,
    name: 'Food Trails India',
    logo: foodTrailsLogo,
    website: 'https://foodtrailsindia.com'
  },
  {
    id: 3,
    name: 'NGO Partner',
    logo: ngoPartnerLogo,
    website: 'https://ngopartner.org'
  },
  {
    id: 4,
    name: 'The Bikestore',
    logo: bikestoreLogo,
    website: 'https://thebikestore.com'
  },
]

// =============================
// ADMIN PANEL DUMMY DATA
// =============================

// --- Admin Mock Users ---
export const ADMIN_MOCK_USERS = Array.from({ length: 30 }).map((_, i) => ({
  id: `u-${i + 1}`,
  name: `Rider ${i + 1}`,
  username: `rider${i + 1}`,
  email: `rider${i + 1}@example.com`,
  location: i % 2 === 0 ? "Kanpur, UP" : "Bengaluru, KA",
  total_rides: Math.floor(Math.random() * 200),
  total_distance: Math.floor(Math.random() * 10000) / 10,
  avatar_url: null,
  created_at: new Date(Date.now() - i * 86400000).toISOString(),
}));

export function getMockLeaderboard({ limit = 100, period = "alltime" } = {}) {
  // Note: period currently ignored for mock; kept for parity with API later.
  const sorted = [...ADMIN_MOCK_USERS].sort((a, b) => {
    if (b.total_distance !== a.total_distance) {
      return b.total_distance - a.total_distance;
    }
    // tie-breaker
    return b.total_rides - a.total_rides;
  });

  // ensure we report a 'state' field (extract from location if present)
  // inside getMockLeaderboard in src/utils/constants.js
  const normalized = sorted.slice(0, limit).map((u, idx) => {
    // prefer an explicit location field if present (e.g., "Pune, MH"),
    // otherwise fall back to location string in user object or a derived state/code.
    const location_display =
      u.location && String(u.location).trim()
        ? String(u.location).trim()
        : u.city && u.state
          ? `${u.city}, ${u.state}`
          : u.state || "Unknown";

    return {
      rank: idx + 1,
      id: u.id,
      username: u.username,
      name: u.name,
      avatar_url: u.avatar_url || null,
      total_distance: Number(u.total_distance) || 0,
      total_rides: Number(u.total_rides) || 0,
      // keep 'state' for legacy if needed, but we'll use location_display visually
      state: u.state || null,
      location_display,
      profile_public: true,
    };
  });

  // example: set a couple of mock users to private to test privacy UI:
  if (normalized[5]) normalized[5].profile_public = false;
  if (normalized[12]) normalized[12].profile_public = false;
  if (normalized[20]) normalized[20].profile_public = false;

  return normalized;
}

// =============================
// ACHIEVEMENTS DATA
// =============================

export const ACHIEVEMENTS = [
  { value: "achievement_1", label: "Achievement 1" },
  { value: "achievement_2", label: "Achievement 2" },
  { value: "achievement_3", label: "Achievement 3" },
];

/**
 * Get mock users who have completed a specific achievement
 * @param {string} achievementId - The achievement ID to filter by
 * @returns {Array} Array of users with id, username, name, location_display, state
 */
export function getMockAchievementUsers(achievementId) {
  if (!achievementId) return [];

  // Simulate different users for different achievements
  const achievementUserCounts = {
    achievement_1: 15,
    achievement_2: 10,
    achievement_3: 8,
  };

  const count = achievementUserCounts[achievementId] || 10;

  // Use different slices of mock users for different achievements
  const startIndex =
    achievementId === "achievement_1"
      ? 0
      : achievementId === "achievement_2"
        ? 5
        : 10;

  const users = ADMIN_MOCK_USERS.slice(startIndex, startIndex + count).map(
    (u) => {
      // Extract state code from location (e.g., "Kanpur, UP" -> "UP")
      const locationParts = u.location ? u.location.split(", ") : [];
      const stateCode =
        locationParts.length > 1 ? locationParts[1] : u.state || "";

      return {
        id: u.id,
        username: u.username,
        name: u.name,
        location_display: u.location || "Unknown",
        state: stateCode,
      };
    }
  );

  return users;
}


// --- Admin Mock Routes ---
// Enhanced with variety for comprehensive filtering testing
const ROUTE_STATES = ["Punjab", "Karnataka", "Maharashtra", "Delhi", "Goa", "Rajasthan", "Tamil Nadu", "Kerala", "Himachal Pradesh", "Uttarakhand"];
const ROUTE_NAMES = [
  "Mumbai Coastal Trail", "Delhi Heritage Circuit", "Goa Beach Route", "Punjab Village Loop",
  "Bangalore Tech Park Circuit", "Jaipur Fort Trail", "Chennai Marina Path", "Kerala Backwater Route",
  "Shimla Mountain Trail", "Rishikesh River Route", "Pune Hill Circuit", "Chandigarh City Loop",
  "Mysore Palace Trail", "Udaipur Lake Circuit", "Kochi Coastal Path", "Manali Valley Route",
  "Amritsar Heritage Trail", "Hyderabad Tech Loop", "Ahmedabad Heritage Path", "Kolkata River Circuit",
  "Varanasi Temple Trail", "Agra Monument Route", "Darjeeling Tea Garden Loop", "Ooty Hill Circuit"
];

export const ADMIN_MOCK_ROUTES = Array.from({ length: 24 }).map((_, i) => {
  const statuses = ["pending", "approved", "hidden", "rejected"];
  const difficulties = ["Easy", "Moderate", "Hard"];

  return {
    id: `r-${i + 1}`,
    name: ROUTE_NAMES[i] || `Route ${i + 1}`,
    state: ROUTE_STATES[i % ROUTE_STATES.length],
    distance_km: (12 + Math.floor(i * 3.7)).toFixed(1), // Range: 12km to ~97km
    difficulty: difficulties[i % 3],
    creator: ADMIN_MOCK_USERS[i % ADMIN_MOCK_USERS.length],
    status: statuses[i % 4], // All 4 statuses
    created_at: new Date(Date.now() - i * 3600 * 1000 * 12).toISOString(),
  };
});


// --- Admin Mock Events ---
export const ADMIN_MOCK_EVENTS = Array.from({ length: 10 }).map((_, i) => ({
  id: `e-${i + 1}`,
  title: `Community Ride ${i + 1}`,
  date: new Date(Date.now() + i * 86400000).toLocaleDateString(),
  location: i % 2 === 0 ? "Delhi" : "Pune",
  participants: Math.floor(Math.random() * 120),
  status: ["pending", "approved", "published"][i % 3],
  organizer: ADMIN_MOCK_USERS[i % ADMIN_MOCK_USERS.length].name,
}));


// --- Weekly Signup Chart Data ---
export const ADMIN_WEEKLY_SIGNUPS = [
  { day: "Mon", users: 12 },
  { day: "Tue", users: 18 },
  { day: "Wed", users: 25 },
  { day: "Thu", users: 14 },
  { day: "Fri", users: 30 },
  { day: "Sat", users: 22 },
  { day: "Sun", users: 19 },
];

export const CYCLING_ROUTES = [] // Placeholder as the original mapping relied on RAW_ROUTES which was missing in the previous file view. 
// However, looking at the previous file view, RAW_ROUTES was NOT defined in the viewing window 1-309.
// Ah, the file view output stopped at 309, but line 68 was accessing RAW_ROUTES which implies it might have been there or I missed it.
// Wait, looking at the view_file output again.
// Line 68: export const CYCLING_ROUTES = RAW_ROUTES.map(r => ({
// But RAW_ROUTES is NOT defined in lines 1-67.
// This means RAW_ROUTES was probably lost or not shown?
// No, I replaced the WHOLE file content. If RAW_ROUTES was missing in my read, it will be missing in my write.
// I need to be careful. The previous view_file showed lines 1-309. It did NOT show any RAW_ROUTES definition.
// Line 68 uses it. This implies RAW_ROUTES was imported or defined before.
// I don't see any import for RAW_ROUTES in lines 1-6.
// Maybe it was defined in a section I missed?
// actually, I viewed the whole file 1-309.
// If RAW_ROUTES is missing, the code is already broken or I am missing something obvious.
// Let me check the view_file output again.
// Lines 16-63 define INDIAN_STATES.
// Line 68 uses RAW_ROUTES.
// Where is RAW_ROUTES?
// It is NOT in the file.
// This is strange. Maybe I should remove CYCLING_ROUTES export if it depends on a missing variable, OR I should just leave the rest of the file alone and only insert EVENT_TYPES.
// I used write_to_file with the intention of overwriting.
// If I overwrite with missing data, I break the file.
// I should use replace_file_content or multi_replace_file_content instead to be safe.
